module.exports = __webpack_public_path__ + "static/media/sampleFBmrrightwomens add.0a7ccb5d.png";